import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_2 = { class: "line-clamp-1 hover:line-clamp-none hover:break-all" }
const _hoisted_3 = { class: "line-clamp-1 hover:line-clamp-none hover:break-all" }

import { shortLocaleString, localeDateString } from "@/helpers/datehelper";
import {
  nameFromUid,
  profileFromUid,
} from "@/helpers/requestHelpers/publicDataRequests";
import DialogCard from "@/components/DialogCard.vue";
import { ref, onMounted, watch } from "vue";
import { Profile } from "@/interfaces/profile";
import { ManagedPatientDataPoint } from "@/interfaces/managedPatient";
import { useManagedPatientsStore } from "@/store/managedPatientsStore";
import ChangelogEntry from "@/components/ChangelogEntry.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

interface ChangeRecord {
  property: string;
  from: any;
  to: any;
  by?: Profile;
  byName: string;
  time: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileHistory',
  props: {
    ofUser: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const history = ref<ManagedPatientDataPoint[] | null>(null);

watch(
  () => props.ofUser,
  () => {
    changelog();
  }
);

onMounted(() => {
  changelog();
});

async function changelog() {
  history.value = null;
  if (props.ofUser == null) {
    return;
  }
  history.value = await useManagedPatientsStore().loadPatientHistoryOf(
    props.ofUser
  );
}

function findChangesOverTime(
  messages: ManagedPatientDataPoint[]
): ChangeRecord[] {
  if (messages.length < 2) {
    return [];
  }

  const changeRecords: ChangeRecord[] = [];

  for (let i = 1; i < messages.length; i++) {
    const previousMsg = messages[i - 1];
    const currentMsg = messages[i];
    const byName = nameFromUid(currentMsg.created_by);
    const by = profileFromUid(currentMsg.created_by);
    const at = shortLocaleString(currentMsg.created_at);

    const previousObject = previousMsg.decrypted_data;
    const currentObject = currentMsg.decrypted_data;

    Object.keys(currentObject).forEach((property) => {
      let from = undefined;
      let to = currentObject[property];
      if (Object.prototype.hasOwnProperty.call(previousObject, property)) {
        from = previousObject[property];
      }
      if (property == "birthday") {
        to = localeDateString(to);
        if (from) {
          from = localeDateString(from);
        }
      }
      if (from != to) {
        changeRecords.push({
          property,
          from: from,
          to: to,
          by: by ?? undefined,
          byName: byName,
          time: at,
        });
      }
    });
  }

  return changeRecords;
}

function translatedProperty(property: string): string | null {
  switch (property) {
    case "birthday":
      return "Geburtstag";
    case "veka":
      return "VeKa-Nr.";
    case "sex":
      return "Geschlecht";
    case "firstName":
      return "Vorname";
    case "lastName":
      return "Nachname";
    default:
      return property;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogCard, {
    "show-footer": false,
    title: "Änderungsverlauf",
    "is-visible": props.ofUser != null,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
  }, {
    default: _withCtx(() => [
      (history.value == null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingSpinner)
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(findChangesOverTime(history.value).reverse(), (change) => {
            return (_openBlock(), _createBlock(ChangelogEntry, {
              "change-by": change.by ?? null,
              "change-text": translatedProperty(change.property) ?? '',
              "change-time": change.time,
              class: "block w-full md:flex",
              key: `${change.by}${change.time}`
            }, {
              from: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(change.from ?? " - "), 1)
              ]),
              to: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(change.to), 1)
              ]),
              _: 2
            }, 1032, ["change-by", "change-text", "change-time"]))
          }), 128)),
      (history.value && history.value.length > 0)
        ? (_openBlock(), _createBlock(ChangelogEntry, {
            key: 2,
            "change-by": _unref(profileFromUid)(history.value[0].created_by) ?? null,
            "change-text": "",
            "change-time": _unref(shortLocaleString)(history.value[0].created_at)
          }, {
            custom: _withCtx(() => [
              _createTextVNode("Eintrag erstellt")
            ]),
            _: 1
          }, 8, ["change-by", "change-time"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})